import { parse } from 'date-fns';

export const parseYMD = (date: string | Date) =>
  typeof date === 'string' ? parse(date, 'yyyy-MM-dd', new Date()) : date;

export const coerceToDate = (d: Date | string): Date => {
  let date = d;

  if (typeof date === 'string') {
    date = parseYMD(date.split('T')[0]);
  }

  if (!d) return new Date();

  return date;
};
